import { render, staticRenderFns } from "./RelatorioConsumoItensContratoFiltro.vue?vue&type=template&id=810cb914"
import script from "./RelatorioConsumoItensContratoFiltro.vue?vue&type=script&lang=js"
export * from "./RelatorioConsumoItensContratoFiltro.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports